import reports from './domains/reports';
import dashboard from './domains/dashboard';
import food from './domains/food';
import labor from './domains/labor';
import cash from './domains/cash';
import service from './domains/service';
import shift from './domains/shift';
import people from './domains/people';
import digital from './domains/digital';
import payroll from './domains/payroll';
import sales from './domains/sales';
import commsHub from './domains/commsHub';
import dashboardTooltips from './domains/dashboardTooltips';
import product from './domains/product';
import dayparts from './domains/dayparts';

const domains = [reports, dashboard, food, labor, cash, service, people, digital, shift, dayparts, payroll, sales, commsHub, product, dashboardTooltips];

const merged = { en: {}, es: {} };

for (const domain of domains) {
  Object.assign(merged.en, domain.en);
  Object.assign(merged.es, domain.es);
}

export default merged;
